export const LOAD_REQUESTED = "V2DASHBOARDWIDGET/LOAD_REQUESTED";
export const LOAD_SUCCESS = "V2DASHBOARDWIDGET/LOAD_SUCCESS";
export const LOAD_FAIL = "V2DASHBOARDWIDGET/LOAD_FAIL";

export default (state = {}, { type }) => {
    switch (type) {
    case LOAD_REQUESTED: {
        return state;
    }
    case LOAD_SUCCESS: {
        return state;
    }
    case LOAD_FAIL: {
        return state;
    }
    default: return state;
    }
};

export const requestLoadv2dashboardwidget = data => ({ type: LOAD_REQUESTED, data });
export const successLoadv2dashboardwidget = data => ({ type: LOAD_SUCCESS, data });
export const failLoadv2dashboardwidget = data => ({ type: LOAD_FAIL, data });
